export default {
  toast_messages: {
    google_review_uploaded: 'Deine Bewertung wurde erfolgreich überprüft. Du hast {{points}} pts verdient 😉',
  },
};
